import React, { useState } from 'react';
import { Section } from '../Section';
import { InView } from '../InView';
import { SectionHeadline } from '../SectionHeadline';
import { WebsiteSnakDemo } from '../WebsiteSnakDemo';
import { websiteSteps } from '../../../data/deck';
export function WebsiteSection() {
  const [open, setOpen] = useState(false);
  const activeKey = open ? 'B' : 'A';
  return <Section id="website" data-id="element-645" data-mp="pba8mur02uf7">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-16" data-id="element-646" data-mp="u925822lb4pq">
        <InView data-id="element-647" data-mp="z73wvbe30cct">
          <SectionHeadline lead="Same website." follow="A more effortless experience." data-id="element-648" data-mp="z6u2lbm07j1b" />
        </InView>
        <InView delay={0.1} data-id="element-649" data-mp="13aa1yfpgjxhp">
          <p className="text-[14.5px] leading-[1.7] text-[var(--muted)]" data-id="element-650" data-mp="13a064bhqew43">
            Today, HCPs navigate, search, scroll and read to understand individualized dosing. What if we also offered them a
            lean-back option?
          </p>
          <span className="mt-4 inline-flex rounded-full bg-[var(--fg)] px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-651" data-mp="39z525scism3a">
            Practical pilot · Optional layer · No redesign
          </span>
        </InView>
      </div>

      <InView delay={0.15} className="mt-12" data-id="element-652" data-mp="k0b7nqzhsswq">
        <div className="mx-auto max-w-[1180px]" data-id="element-653" data-mp="fzhheqykv20o">
          <WebsiteSnakDemo open={open} onOpenChange={setOpen} data-id="element-654" data-mp="g091b4itbbb4" />
        </div>
      </InView>

      <InView delay={0.22} data-id="element-655" data-mp="b2hdallag9c7">
        <div className="mx-auto mt-6 grid max-w-[1180px] gap-3 sm:grid-cols-2" data-id="element-656" data-mp="az38z7t2dq24">
          {websiteSteps.map(step => {
          const active = step.key === activeKey;
          return <button key={step.key} type="button" onClick={() => setOpen(step.key === 'B')} aria-pressed={active} className={['flex items-start gap-4 rounded-[18px] p-4 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]', active ? 'bg-white ring-1 ring-[var(--fg)]/10' : 'hover:bg-white/60'].join(' ')} data-id="element-657" data-mp="13nr0vm8bjdon">
                <span className={['flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[14px] font-extrabold transition-colors', active ? 'bg-[var(--brand)] text-white' : 'border border-[var(--fg)]/25 text-[var(--fg)]'].join(' ')} data-id="element-658" data-mp="3kxwoodqlkm4v">
                  {step.key}
                </span>
                <span data-id="element-659" data-mp="2x6hlkiqzy0sk">
                  <span className="block text-[17px] font-extrabold leading-tight tracking-[-0.02em] text-[var(--fg)]" data-id="element-660" data-mp="31zkgovbf9iav">
                    {step.title}
                  </span>
                  <span className="mt-1 block max-w-[46ch] text-[13px] leading-relaxed text-[var(--muted)]" data-id="element-661" data-mp="2s97l8822k4py">{step.caption}</span>
                </span>
              </button>;
        })}
        </div>
      </InView>

      <InView delay={0.3} data-id="element-662" data-mp="2j92rv1tpn6us">
        <div className="mt-14 flex flex-col gap-3 border-t border-[var(--fg)]/10 pt-8 lg:flex-row lg:items-baseline lg:justify-between lg:gap-10" data-id="element-663" data-mp="2j785rk6pd8p4">
          <p className="text-[24px] font-extrabold leading-[1.1] tracking-[-0.03em] text-[var(--fg)] sm:text-[30px]" data-id="element-664" data-mp="1unoah77kb985">
            Lean forward when you want to. Lean back when you prefer to.
          </p>
          <p className="max-w-[36ch] text-[13px] leading-relaxed text-[var(--muted)]" data-id="element-665" data-mp="24m40f6uuscg2">
            The Snak complements the existing REKOVELLE website rather than replacing it.
          </p>
        </div>
      </InView>
    </Section>;
}